<template>
  <div>
    <div style="text-align: left">
      <div class="searchbarcls">
        企业名称:<el-input size="small" v-model="searchForm.tenantName" style="width: 200px;"></el-input>
        &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="loadTableData()">查询</el-button>
      </div>
      <div style="padding: 2px;">
        <el-button type="primary" plain style="height: 30px" size="small" @click="showAddDialog()">新 增</el-button>
      </div>
    </div>
    <el-table ref="myElTable" background="true" :data="tableData" @row-click="tableTrClick" border style="width: 100%;">
      <el-table-column type="selection" width="42" />
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="tenantPid" label="企业编号" width="165" />
      <el-table-column prop="tenantName" label="企业名称" width="310" />
      <el-table-column prop="tenantPeople" label="联系人" width="130" />
      <el-table-column prop="thephone" label="联系电话" />
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" plain @click="showUpdateDialog(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" plain @click="deleteTenant(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.currPage" :page-sizes="[20, 30, 40]" :page-size="30"
                   layout="total,jumper, prev, pager, next,sizes" :total="searchForm.dataTotal">
    </el-pagination>
    <!--添加div-->
    <el-dialog title="新增企业信息" size="33%" :visible.sync="drawer" :wrapperClosable="false" direction="rtl">
      <AddTenantWindow ref="addTenantWindow" :closeWindow="closeWindow"></AddTenantWindow>
    </el-dialog>
    <!--添加div-->
    <el-dialog title="修改企业信息" size="33%" :visible.sync="udrawer" :wrapperClosable="false" direction="rtl">
      <UpdateTenantWindow ref="updateTenantWindow" :tenantData="tenantData" :closeWindow="closeWindow"></UpdateTenantWindow>
    </el-dialog>
  </div>
</template>
<script>
import AddTenantWindow from "./AddTenantWindow.vue";
import UpdateTenantWindow from "./UpdateTenantWindow.vue";
import { appjs } from "@/utiljs/apputil";
export default {
  components: {
    AddTenantWindow,
    UpdateTenantWindow
  },
  props: {
    clientHeight: {
      type: Number
    }
  },
  data () {
    return {
      otherHeight: 210,
      drawer: false,
      udrawer: false,
      tenantData: {},
      searchForm: {
        dataTotal: 0,
        pageSize: 20,
        currPage: 1,
        tenantName: ''
      },
      tableData: []
    }
  },
  created () {
    this.loadTableData(1);
  },
  methods: {
    closeWindow (msg) {
      this.drawer = false;
      this.udrawer = false;
      if (msg) {
        this.loadTableData(1);
        appjs.showSuccessMsg(msg, 2000, 50);
      }
    },
    loadTableData () {
      let load = appjs.loading();
      let _self = this;
      let params = this.searchForm;
      appjs.httpRequest('tenant/queryTenant', params).then(
        (data) => {
          if (data.retCode && data.retCode != "ok") {
            appjs.showErrorMsg(data.retMsg)
          } else {
            _self.searchForm.dataTotal = data.totalRowNum;
            _self.tableData = data.dataList;
            this.$refs.myElTable.bodyWrapper.scrollTop = 0;
          }
          appjs.unloading(load);
        }
      ).catch(
        (errmsg) => {
          appjs.showErrorMsg(errmsg)
          appjs.unloading(load);
        });
    },
    deleteTenant (rowdata) {
      let _self = this;
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        let load = appjs.loading('数据删除中');
        appjs.httpRequest('tenant/deleteTenant', { tenantPid: rowdata.tenantPid }).then(
          (data) => {
            if (data.retCode && data.retCode != "ok") {
              appjs.unloading(load);
              appjs.showErrorMsg(data.retMsg)
            } else {
              appjs.unloading(load);
              appjs.showSuccessMsg(data.retMsg)
              _self.loadTableData();
            }
          }
        ).catch(
          (errmsg) => {
            appjs.showErrorMsg(errmsg)
            appjs.unloading(load);
          });
      });
    },
    tableTrClick (row, column, event) {
      this.$refs.myElTable.clearSelection();
      this.$refs.myElTable.toggleRowSelection(row);
    },
    handleSizeChange (val) {
      this.searchForm.pageSize = val;
      this.loadTableData();
    },
    handleCurrentChange (val) {
      this.searchForm.currPage = val;
      this.loadTableData();
    },
    showAddDialog () {
      console.log(localStorage.getItem("authorization"))
      this.drawer = true;
      if (this.$refs['addTenantWindow']) {
        this.$refs['addTenantWindow'].resertForm();
      }
    },
    showUpdateDialog (rowdata) {
      this.udrawer = true;
      this.tenantData = JSON.parse(JSON.stringify(rowdata));
      let _self = this;
      this.$nextTick(() => {
        if (_self.$refs['updateTenantWindow']) {
          _self.$refs['updateTenantWindow'].resertForm();
        }
      })
    }
  }
}
</script>
